import request from "~/utils/http";

const utilsApi = {
	gets : async (params) => {
		const url = '/utils';
		return await request.get(url);
	},
	qrPayment: async (params) => {
		const url = '/utils/qr-payment';
		return await request.post(url, params);
	}
};

export default utilsApi;